<div class="price-list-panel" *ngIf="withData; else noData">
  <div class="price-list-panel__filter" *ngIf="priceListFilters">
    <lx-price-lists-portal-destination-filter
      [priceListFilters]="priceListFilters"
      (filtersChanged)="filtersChanged.emit($event)"
    ></lx-price-lists-portal-destination-filter>
  </div>
  <div class="price-list-panel__panel" [ngClass]="{ 'price-list-panel__panel--without-filter': !priceListFilters }">
    <ng-content></ng-content>
  </div>
</div>

<ng-template #noData>
  <p class="price-list-panel__no-data">
    Sorry, there is no price list data available at the moment. Please contact your Kaplan/Alpadia partner at
    <a href="mailto:klgpartners@kaplaninternational.com">klgpartners&#64;kaplaninternational.com</a>
  </p>
</ng-template>
